import { css } from '@emotion/core';
import DroppedIceCream from '@olxeu-a2b/ui/src/commons/components/icons/DroppedIceCream';
import styled from '../../../theme/styled';

import mq from '../../styles/mediaQueries';

const Wrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    background-color: ${theme.colors['background-global-secondary']};

    ${mq.tablet} {
      padding-top: 56px;
    }
  `}
`;

const PageWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.colors.yellowBgLight};
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${theme.sizes['16']};
    text-align: center;
    width: 100%;

    ${mq.tablet} {
      border: 16px solid white;
      box-sizing: border-box;
      max-height: 426px;
      max-width: 824px;
    }
  `}
  }
`;

const DroppedIceCreamIcon = styled(DroppedIceCream)`
  transform: scale(0.8);
`;

export default {
  Wrapper,
  PageWrapper,
  DroppedIceCreamIcon,
};
